"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [0, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("util");

var permission_1 = require("./permission");

function All() {
  return true;
}

exports.All = All;

var AccessControlPlus = function () {
  function AccessControlPlus(roles) {
    if (roles === void 0) {
      roles = {};
    }

    this.roles = roles;
  }

  AccessControlPlus.prototype.grant = function (roleName) {
    this.ensureRole(roleName);
    return new Role(this.roles, roleName, 'grant');
  };

  AccessControlPlus.prototype.deny = function (roleName) {
    this.ensureRole(roleName);
    return new Role(this.roles, roleName, 'deny');
  };

  AccessControlPlus.prototype.can = function (roleNames, scope, context) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, resourceName, actionName, field, permission, _i, roleNames_1, roleName;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = scope.split(':'), resourceName = _a[0], actionName = _a[1], field = _a[2];
            permission = new permission_1.Permission();
            roleNames = util_1.isArray(roleNames) ? roleNames : [roleNames];
            _i = 0, roleNames_1 = roleNames;
            _b.label = 1;

          case 1:
            if (!(_i < roleNames_1.length)) return [3, 4];
            roleName = roleNames_1[_i];
            return [4, this.canRole(roleName, resourceName, actionName, field, context, permission)];

          case 2:
            _b.sent();

            if (permission.granted) {
              return [3, 4];
            }

            _b.label = 3;

          case 3:
            _i++;
            return [3, 1];

          case 4:
            return [2, permission];
        }
      });
    });
  };

  AccessControlPlus.prototype.getWithDefaultWildcard = function (key, obj) {
    var value = obj[key];

    if (value) {
      return [key, value];
    } else {
      return ['*', obj['*']];
    }
  };

  AccessControlPlus.prototype.canRole = function (roleName, resourceName, actionName, field, context, permission) {
    return __awaiter(this, void 0, void 0, function () {
      var role, resource, action, testedRoleName, testedResourceName, testedActionName, actionPath, _a, granted, terminate, _i, _b, inheritedRole, _c, _d, _e;

      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            _c = this.getWithDefaultWildcard(roleName, this.roles), testedRoleName = _c[0], role = _c[1];
            if (!role) return [3, 7];
            _d = this.getWithDefaultWildcard(resourceName, role.resources), testedResourceName = _d[0], resource = _d[1];
            if (!resource) return [3, 2];
            _e = this.getWithDefaultWildcard(actionName, resource), testedActionName = _e[0], action = _e[1];
            if (!action) return [3, 2];
            actionPath = testedRoleName + ":" + testedResourceName + ":" + testedActionName;
            return [4, this.canAction(action, actionPath, field, context, permission)];

          case 1:
            _a = _f.sent(), granted = _a[0], terminate = _a[1];

            if (terminate) {
              return [2, granted];
            }

            _f.label = 2;

          case 2:
            if (!role.inherits) return [3, 6];
            _i = 0, _b = role.inherits;
            _f.label = 3;

          case 3:
            if (!(_i < _b.length)) return [3, 6];
            inheritedRole = _b[_i];
            return [4, this.canRole(inheritedRole, resourceName, actionName, field, context, permission)];

          case 4:
            if (_f.sent()) {
              return [2, true];
            }

            _f.label = 5;

          case 5:
            _i++;
            return [3, 3];

          case 6:
            permission.deny();
            _f.label = 7;

          case 7:
            return [2, false];
        }
      });
    });
  };

  AccessControlPlus.prototype.ensureRole = function (roleName) {
    if (!this.roles[roleName]) {
      this.roles[roleName] = {
        resources: {}
      };
    }
  };

  AccessControlPlus.prototype.testCondition = function (condition, context) {
    return __awaiter(this, void 0, void 0, function () {
      var e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4, condition(context)];

          case 1:
            return [2, _a.sent()];

          case 2:
            e_1 = _a.sent();
            return [2, false];

          case 3:
            return [2];
        }
      });
    });
  };

  AccessControlPlus.prototype.canAction = function (action, actionPath, field, context, permission) {
    return __awaiter(this, void 0, void 0, function () {
      var granted, terminate, scopeIndex, _i, action_1, scope, scopePath, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            terminate = false;
            scopeIndex = 0;
            _i = 0, action_1 = action;
            _b.label = 1;

          case 1:
            if (!(_i < action_1.length)) return [3, 4];
            scope = action_1[_i];
            scopePath = scope.effect + ":" + actionPath + ":" + scopeIndex;
            return [4, this.canScope(scope, scopePath, field, context, permission)];

          case 2:
            _a = _b.sent(), granted = _a[0], terminate = _a[1];

            if (terminate) {
              return [2, [granted, terminate]];
            }

            scopeIndex++;
            _b.label = 3;

          case 3:
            _i++;
            return [3, 1];

          case 4:
            return [2, [false, false]];
        }
      });
    });
  };

  AccessControlPlus.prototype.canScope = function (scope, scopePath, field, context, permission) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(scope.effect === 'grant')) return [3, 2];
            return [4, this.canGrantScope(scope, scopePath, field, context, permission)];

          case 1:
            return [2, _a.sent()];

          case 2:
            return [4, this.canDenyScope(scope, scopePath, field, context, permission)];

          case 3:
            return [2, _a.sent()];
        }
      });
    });
  };

  AccessControlPlus.prototype.canGrantScope = function (scope, scopePath, field, context, permission) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, success, fields, permissionPath, constraint, _b;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.testScope(scope, scopePath, field, context)];

          case 1:
            _a = _c.sent(), success = _a[0], fields = _a[1], permissionPath = _a[2];
            if (!success) return [3, 5];
            if (!(scope.constraint instanceof Function)) return [3, 3];
            return [4, scope.constraint(context)];

          case 2:
            _b = _c.sent();
            return [3, 4];

          case 3:
            _b = scope.constraint;
            _c.label = 4;

          case 4:
            constraint = _b;
            permission.grant(permissionPath, fields, constraint);
            return [2, [true, true]];

          case 5:
            permission.deny(permissionPath, fields);
            return [2, [false, false]];
        }
      });
    });
  };

  AccessControlPlus.prototype.canDenyScope = function (scope, scopePath, field, context, permission) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, success, fields, permissionPath;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.testScope(scope, scopePath, field, context)];

          case 1:
            _a = _b.sent(), success = _a[0], fields = _a[1], permissionPath = _a[2];

            if (success) {
              permission.deny(permissionPath, fields);
              return [2, [false, true]];
            } else {
              return [2, [false, false]];
            }

            return [2];
        }
      });
    });
  };

  AccessControlPlus.prototype.testScope = function (scope, scopePath, field, context) {
    return __awaiter(this, void 0, void 0, function () {
      var fields, _a, matchedField, fieldTest, conditionTest, _b, permissionPath, success;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.generateFields(scope, context)];

          case 1:
            fields = _c.sent();
            _a = field ? permission_1.Permission.testField(field, fields) : [undefined, true], matchedField = _a[0], fieldTest = _a[1];
            _b = fieldTest;
            if (!_b) return [3, 3];
            return [4, this.testCondition(scope.condition, context)];

          case 2:
            _b = _c.sent();
            _c.label = 3;

          case 3:
            conditionTest = _b;
            permissionPath = this.permissionPath(scopePath, matchedField, fieldTest, scope.condition);
            success = !!(fieldTest && conditionTest);
            return [2, [success, fields, permissionPath]];
        }
      });
    });
  };

  AccessControlPlus.prototype.permissionPath = function (scopePath, field, fieldTest, condition) {
    var conditionName = fieldTest ? condition ? condition.name || 'unnamedCondition' : '' : '';
    return scopePath + ":" + (field ? field : '') + ":" + conditionName;
  };

  AccessControlPlus.prototype.generateFields = function (scope, context) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!scope.fieldGenerator) return [3, 2];
            return [4, scope.fieldGenerator(context)];

          case 1:
            return [2, _a.sent()];

          case 2:
            return [2, {}];
        }
      });
    });
  };

  return AccessControlPlus;
}();

exports.AccessControlPlus = AccessControlPlus;

var Role = function (_super) {
  __extends(Role, _super);

  function Role(roles, roleName, effect) {
    var _this = _super.call(this, roles) || this;

    _this.roleName = roleName;
    _this.effect = effect;
    return _this;
  }

  Role.prototype.inherits = function (roleName) {
    var superRoles = this._role.inherits;

    if (superRoles) {
      if (!superRoles.includes(roleName)) {
        superRoles.push(roleName);
      }
    } else {
      this._role.inherits = [roleName];
    }

    return this;
  };

  Role.prototype.resource = function (resourceName) {
    if (!this._role.resources.hasOwnProperty(resourceName)) {
      this._role.resources[resourceName] = {};
    }

    return new Resource(this.roles, this.roleName, this.effect, resourceName);
  };

  Role.prototype.scope = function (scope) {
    var _a = scope.split(':'),
        resource = _a[0],
        action = _a[1];

    return this.resource(resource).action(action);
  };

  Object.defineProperty(Role.prototype, "_role", {
    get: function get() {
      return this.roles[this.roleName];
    },
    enumerable: true,
    configurable: true
  });
  return Role;
}(AccessControlPlus);

exports.Role = Role;

var Resource = function (_super) {
  __extends(Resource, _super);

  function Resource(roles, roleName, effect, resourceName) {
    var _this = _super.call(this, roles, roleName, effect) || this;

    _this.resourceName = resourceName;
    return _this;
  }

  Resource.prototype.action = function (actionName) {
    if (!this._resource[actionName]) {
      this._resource[actionName] = [];
    }

    var scopes = this._resource[actionName];
    var scopeIndex = scopes.length;
    scopes.push({
      condition: All,
      constraint: {},
      effect: this.effect
    });
    return new Scope(this.roles, this.roleName, this.effect, this.resourceName, actionName, scopeIndex);
  };

  Object.defineProperty(Resource.prototype, "create", {
    get: function get() {
      return this.action('create');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Resource.prototype, "read", {
    get: function get() {
      return this.action('read');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Resource.prototype, "update", {
    get: function get() {
      return this.action('update');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Resource.prototype, "delete", {
    get: function get() {
      return this.action('delete');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Resource.prototype, "_resource", {
    get: function get() {
      return this.roles[this.roleName].resources[this.resourceName];
    },
    enumerable: true,
    configurable: true
  });
  return Resource;
}(Role);

exports.Resource = Resource;

var Scope = function (_super) {
  __extends(Scope, _super);

  function Scope(roles, roleName, effect, resourceName, actionName, scopeIndex) {
    var _this = _super.call(this, roles, roleName, effect, resourceName) || this;

    _this.actionName = actionName;
    _this.scopeIndex = scopeIndex;
    return _this;
  }

  Scope.prototype.withConstraint = function (constraint) {
    this._scope.constraint = constraint;
    return this;
  };

  Scope.prototype.onDynamicFields = function (fieldGen) {
    this._scope.fieldGenerator = fieldGen;
    return this;
  };

  Scope.prototype.onFields = function () {
    var fieldNames = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      fieldNames[_i] = arguments[_i];
    }

    var fnameRE = /^([!]?)(.+)/;
    var fieldMap = {};

    for (var _a = 0, fieldNames_1 = fieldNames; _a < fieldNames_1.length; _a++) {
      var field = fieldNames_1[_a];
      var match = fnameRE.exec(field);

      if (!match) {
        throw new Error("Invalid field name: " + field);
      } else {
        fieldMap[match[2]] = match[1] !== '!';
      }
    }

    this._scope.fieldGenerator = function (context) {
      return fieldMap;
    };

    return this;
  };

  Scope.prototype.where = function () {
    var conditions = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      conditions[_i] = arguments[_i];
    }

    if (conditions.length === 1) {
      this._condition = conditions[0];
      return this;
    } else {
      return this.and.apply(this, conditions);
    }
  };

  Scope.prototype.or = function () {
    var conditions = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      conditions[_i] = arguments[_i];
    }

    var prevCondition = this.condition;
    var testConditions = prevCondition === All ? conditions : [All].concat(conditions);
    var name = "or(" + conditions.map(function (c) {
      return c.name || 'unknownCondition';
    }).join(',');
    this._condition = (_a = {}, _a[name] = function (_a) {
      var options = __rest(_a, []);

      return testConditions.some(function (c) {
        return c(options);
      });
    }, _a)[name];
    return this;

    var _a;
  };

  Scope.prototype.and = function () {
    var conditions = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      conditions[_i] = arguments[_i];
    }

    var prevCondition = this.condition;
    var testConditions = prevCondition === All ? conditions : [All].concat(conditions);
    var name = "and(" + conditions.map(function (c) {
      return c.name || 'unknownCondition';
    }).join(',');
    this._condition = (_a = {}, _a[name] = function (_a) {
      var options = __rest(_a, []);

      return testConditions.every(function (c) {
        return c(options);
      });
    }, _a)[name];
    return this;

    var _a;
  };

  Object.defineProperty(Scope.prototype, "condition", {
    get: function get() {
      return this._scope.condition;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Scope.prototype, "_condition", {
    set: function set(value) {
      this._scope.condition = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Scope.prototype, "_scope", {
    get: function get() {
      return this._resource[this.actionName][this.scopeIndex];
    },
    enumerable: true,
    configurable: true
  });
  return Scope;
}(Resource);

exports.Scope = Scope;